import PropTypes from 'prop-types';

const AccountSetsEmptyTile = ({ errors, touched }) => {
  const showError = touched?.accountSets?.length === 0 && errors?.accountSets;

  return (
    <>
      <div className="item-tile empty-tile">
        <p>No Account set created yet. Click above button to add Account Sets.</p>
      </div>
      {showError && <p className="gl-accountset-error">{showError}</p>}
    </>
  );
};

AccountSetsEmptyTile.propTypes = {
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AccountSetsEmptyTile;
